import React from "react";
import UaeMofaHead from "../../UaeAttestation/UaeMofa/UaeMofaHead";
import "./../../UaeAttestation/UaeMofa/UaeMofa.css";
import QatarMofaMain from "./QatarMofaMain";

const QatarMofa = () => {
  return (
    <div className="uaeMofaContainer">
      <UaeMofaHead />
      <QatarMofaMain />
    </div>
  );
};

export default QatarMofa;
